<template>
  <v-sheet
  rounded
  class="pa-4">
    <v-row align="center">
      <v-col cols="5">
        <PostCard :post="repostData.post" :search-data="repostData.search_data"></PostCard>
      </v-col>
      <v-col cols="2">{{getPercentMatch}}%</v-col>
      <v-col cols="5">
        <PostCard :post="repostData.repost_of" :search-data="repostData.search_data"></PostCard>
      </v-col>
    </v-row>

  </v-sheet>
</template>

<script>
import PostCard from "@/components/repost_feed/PostCard";
export default {
  name: "Repost",
  components: {PostCard},
  props: {
    repostData: Object
  },
  computed: {
    getPercentMatch: function () {
      let hashSize = 64;
      //let hashSize = this.repostData.search_data.meme_template_used ? 256 : 64;
      let diff = 100 - (this.repostData.repost_data.hamming_distance / hashSize * 100)
      return Math.round((diff + Number.EPSILON) * 100) / 100
    },

  },
  methods: {

  }
}
</script>

<style scoped>

</style>
